<template>
    <div>
        <div class="list-title">
            <h3>Usuarios</h3>
        </div>

        <div class="search-bar">
            <v-container fluid class="pa-0">
                <v-layout row wrap>
                    <v-flex xs12 md3>
                        <v-text-field class='lance' v-model="search.name" label="Nombre" @input="searchOnTable"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md3>
                        <v-text-field class='lance' v-model="search.email" label="Correo Electrónico" @input="searchOnTable"></v-text-field>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-btn fab v-if="credentials.userCreate" color="primary" @click="goTo('userform')">
                        <v-icon dark>add</v-icon>
                    </v-btn>
                </v-layout>
            </v-container>
        </div>
        
        <v-data-table
            :headers="headers"
            :custom-sort="tableCustomSort"
            :items="list"
            :loading="loading"
            class="table-catalog elevation-5">
            <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
            <template slot="items" slot-scope="props" @click="goTo('userform/' + props.item.id)">
                <tr v-bind:class="{ itemToDelete: props.item.id == itemToDelete }"
                    class="cursor-pointer"
                    @click="credentials.userRead? goTo('userdetail/' + props.item.id): null">
                    <td class="text-xs-left">{{ props.item.firstName }} {{ props.item.lastName }}</td>
                    <td class="text-xs-left">{{ props.item.email }}</td>
                    <td class="text-xs-left">{{ props.item.username }}</td>
                    <td class="text-xs-left">{{ props.item.country? props.item.country.name: "" }}</td>
                    <td class="text-xs-right">
                        <v-btn fab small color="primary" 
                            v-if="credentials.userUpdate" 
                            @click.stop="goTo('userform/' + props.item.id)">
                            <img src="@/assets/icon-editar.svg" alt="">
                        </v-btn>
                        <v-btn fab small color="error" 
                            v-if="credentials.userDelete" 
                            @click.stop="confirmDelete(props.item.id)" 
                            :disabled="(currentUserId === props.item.id)">
                            <img src="@/assets/icon-eliminar.svg" alt="">
                        </v-btn>
                    </td>
                </tr>
            </template>
            <template slot="no-data">
                No hay registros para sus parámetros de búsqueda. Favor de intentar otra búsqueda o crear uno nuevo.
            </template>
        </v-data-table>
        <v-dialog v-model="deleteDialog" max-width="350">
            <v-card>
                <v-card-title class="headline">Confirmación</v-card-title>
                <v-card-text>¿Está seguro de querer borrar este registro?</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" flat @click="deleteDialog=false; itemToDelete = '';">Cancelar</v-btn>
                    <v-btn color="primary" flat @click="deleteDialog=false; deleteRegistry(itemToDelete)">Aceptar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>


<script>
    import { events, printList } from '../main';
    import _ from 'underscore';
    import moment from 'moment-timezone';

    export default {
        data () {
            return {
                list: [],
                source: [],
                search: {
                    username: "",
                    name: "",
                    email: "",
                },
                headers: [
                    { text: 'Nombre', value: 'name' },
                    { text: 'Correo Electrónico', value: 'email' },
                    { text: 'Usuario', value: 'username' },
                    { text: 'País', value: 'country' },
                    { text: '', value: 'delete', align: 'center', sortable: false },
                ],
                loading: true,
                deleteDialog: false,
                itemToDelete: '',
                currentUserId: localStorage.getItem('userId'),
                credentials: JSON.parse(localStorage.getItem('userCredentials')),
            }
        },
        methods: {
            snackbar: function(message) {
                events.$emit('snackbar', message);            
            },
            confirmDelete: function(id) {
                this.itemToDelete = id;
                this.deleteDialog = true;
            },
            goTo(url) {
                var self = this;
                self.$router.push('/' + url);
            },
            tableCustomSort(items, index, isDesc) {
                items.sort( (a,b) =>  {
                    if (index == "name") {
                        let aN = a.firstName + a.lastName;
                        let bN = b.firstName + b.lastName;
                        return (aN < bN ? -1 : 1) * (!isDesc? 1: -1);
                    } else {
                        return (a[index] < b[index] ? -1 : 1) * (!isDesc? 1: -1);
                    }
                });
                return items;
            },
            getList: function() {
                this.$http.get('user')
                    .then(response => {
                        var list = response.body;

                        _.each(list, function(item) {
                            if (item.roles.length) {
                                item.rolesnames = item.roles[0].name;
                                _.each(item.roles, function (role) {
                                    if (role != item.roles[0]) {
                                        item.rolesnames += ', ' + role.name;
                                    }
                                });
                            }
                        });

                        this.list = list;
                        this.source = list;
                        this.loading = false;
                    }, error => {
                        this.snackbar('Hubo un problema al obtener la lista');
                        console.error(error);
                    })
            },
            deleteRegistry(id) {
                this.showConfirm = false;
                this.$http.delete('user/' + id)
                    .then(response => {
                        this.itemToDelete = '';
                        this.getList();
                        this.snackbar('El registro ha sido eliminado con éxito');
                    }, error => {
                        this.itemToDelete = '';
                        this.snackbar('Hubo un problema al eliminar el registro');
                        console.error(error);
                    });
            },
            searchOnTable: function() {
                this.list = _.filter(this.source, item => {
                    return item.username.toLowerCase().includes(this.search.username.toLowerCase())
                        && (`${item.firstName} ${item.lastName}`).toLowerCase().includes(this.search.name.toLowerCase())
                        && item.email.toLowerCase().includes(this.search.email.toLowerCase());
                });
            },
        },
        mounted() {
            this.getList();
        },
        filters: {
            moment: function (date) {
                return moment(date).locale("es").format('LL');
            }
        }
    }
</script>